import { DistrictRepository } from '../../domain/repositories/DistrictRepository'
import { DistrictMiniModel } from '../models/DistrictMiniModel'
import type { DistrictMiniEntity } from '../../domain/entities/DistrictsMiniEntity'
import { DistrictModel } from '../models/DistrictModel'
import type { DistrictEntity } from '../../domain/entities/DistrictEntity'
import type { CreateUpdateDistrictEntity } from '../../domain/entities/CreateUpdateDistrictEntity'
import { CreateUpdateDistrictModel } from '../models/CreateUpdateDistrictModel'
import { CreateDistrictResponseModel } from '../models/CreateDistrictResponseModel'
import type { CreateDistrictResponseEntity } from '../../domain/entities/CreateDistrictResponseEntity'
import { DistrictsService, type PostRegionDistrictsAdminRequest } from '@/backend/market'

export class DistrictRepositoryImpl implements DistrictRepository {
  async getDistricts(): Promise<DistrictMiniEntity[] | { error: true }> {
    try {
      const response = await DistrictsService.getRegionDistrictsAdmin()
      const districtsMiniModels = response.regionDistricts?.map(
        (region) => new DistrictMiniModel(region)
      )

      return districtsMiniModels ?? []
    } catch {
      return { error: true }
    }
  }
  async getDistrictById(regionId: number): Promise<DistrictEntity | { error: true }> {
    try {
      const response = await DistrictsService.getDistrictsByRegionAdmin({
        regionId
      })
      const districtModel = new DistrictModel(response)
      return districtModel
    } catch {
      return { error: true }
    }
  }
  async createDistrict(
    data: CreateUpdateDistrictEntity
  ): Promise<CreateDistrictResponseEntity | { error: true }> {
    const createUpdateDistrictModel = new CreateUpdateDistrictModel(data)
    try {
      const response = await DistrictsService.postDistrictsByRegionAdmin({
        requestBody: createUpdateDistrictModel as PostRegionDistrictsAdminRequest
      })
      const createDistrictResponseModel = new CreateDistrictResponseModel(response)

      return createDistrictResponseModel
    } catch {
      return { error: true }
    }
  }
  async deleteDistrict(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await DistrictsService.deleteDistrictAdmin({
        id
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async districtDisability(
    id: number,
    disabled: boolean
  ): Promise<{ success: true } | { error: true }> {
    try {
      await DistrictsService.putDistrictDisabilityAdmin({
        id,
        requestBody: {
          disabled
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
